import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',  // 改这里
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),  // 改这里
    permissionMenuList: [],
    sidebarCollapse: false
  },
  mutations: {
    SET_MENU_PATH_MAP(state, map) {
      state.menuPathMap = map
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)  // 改这里
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info
      localStorage.setItem('userInfo', JSON.stringify(info))  // 改这里
    },
    LOGOUT(state) {
      state.token = ''
      state.userInfo = {}
      localStorage.removeItem('token')  // 改这里
      localStorage.removeItem('userInfo')  // 改这里
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapse = !state.sidebarCollapse
    },
    SET_PERMISSION_MENU(state, menus) {
      state.permissionMenuList = menus
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    userId: state => state.userInfo.userId || null,
    username: state => state.userInfo.username || '',
    roleIdList: state => state.userInfo.roleIdList || [],
    distributorId: state => state.userInfo.distributorId || null,
    parentId: state => state.userInfo.parentId || null,
    permCodes: state => state.userInfo.permCodes || []
  }
})